import { Record } from 'immutable';

import { EntityListEntity } from '../components/entity-list/entity-list.entity';

export const EntitySliceKey = 'main';

export interface IEntityOriginalSliceState {
	loading: boolean;
	list: EntityListEntity;
	includePublicProjects: boolean;
	isLoadingPublicProjectDetails: boolean;
}

export const defaults: IEntityOriginalSliceState = {
	loading: false,
	list: EntityListEntity.build([]),
	includePublicProjects: false,
	isLoadingPublicProjectDetails: false,
};

export class EntityOriginalSliceState extends Record<IEntityOriginalSliceState>(
	defaults
) {
	public static readonly key = EntitySliceKey;

	public setLoading(isLoading: boolean): EntityOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setEntityList(entityList: EntityListEntity): EntityOriginalSliceState {
		return this.set('list', entityList);
	}

	public toggleIncludePublicProjects(
		includePublicProjects: boolean
	): EntityOriginalSliceState {
		return this.set('includePublicProjects', includePublicProjects);
	}

	public setIsLoadingPublicProjectDetails(
		isLoading: boolean
	): EntityOriginalSliceState {
		return this.set('isLoadingPublicProjectDetails', isLoading);
	}
}
